import { render, staticRenderFns } from "./Suppe.vue?vue&type=template&id=15da3f27&scoped=true"
import script from "./Suppe.vue?vue&type=script&lang=js"
export * from "./Suppe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da3f27",
  null
  
)

export default component.exports